export enum AgeRestriction {
  General = 'GENERAL',
  Family = 'FAMILY',
  TwentyOnePlus = '21_PLUS',
} 